import { PosIconProps, SvgWrapper } from './SvgWrapper';

export const PlayIcon = (props: Omit<PosIconProps, 'viewBox'>) => {
  return (
    <SvgWrapper viewBox="0 0 44 32" fill="none" size="" {...props}>
      <path
        d="M18.8 18.8398V12.7602C18.8 12.1084 19.5377 11.7302 20.0669 12.1106L24.2962 15.1504C24.7403 15.4696 24.7403 16.1304 24.2962 16.4496L20.0669 19.4894C19.5377 19.8698 18.8 19.4916 18.8 18.8398Z"
        fill="currentColor"
      />
    </SvgWrapper>
  );
};
